export const iconFontAwesomeConstructionDumpster = (
	<i className="fa-solid fa-dumpster"></i>
);
